{
  "nav": {
    "tools": "Tools",
    "openMenu": "Menü öffnen",
    "subscription": "Abonnement",
    "configuration": "Konfiguration",
    "account": "Konto",
    "administration": "Administration",
    "ourTools": "Unsere Tools",
    "pricing": "Preise",
    "faq": "FAQ"
  },
  "toolItems": {
    "flippingTool": "Flipping Tool",
    "dropshipTool": "Dropship Tool",
    "housingTool": "Housing Tool",
    "inventoryAnalysisTool": "Inventaranalyse-Tool",
    "snipeAlerts": "Snipe-Benachrichtigungen",
    "realmStats": "Server-Statistiken",
    "tsmListGenerator": "TSM-Listengenerator",
    "tsmProfileSetupGuide": "TSM-Profil-Einrichtungsanleitung",
    "dashboard": "Dashboard",
    "classicDeals": "Classic Deals"
  },
  "configItems": {
    "regionRealm": "Region- und Server Einstellungen",
    "personal": "Filter Einstellungen",
    "discord": "Discord Einstellungen"
  },
  "accountItems": {
    "settings": "Einstellungen"
  },
  "adminItems": {
    "stats": "Statistiken",
    "userInfo": "Benutzerinfo",
    "goldSubscription": "Gold-Abonnement",
    "itemLookup": "Artikel-Suche",
    "snipeAudit": "Snipe-Audit",
    "emailPreviews": "E-Mail-Vorschau"
  },
  "buttons": {
    "login": "Einloggen",
    "logout": "Ausloggen",
    "register": "Registrieren",
    "registerNow": "Jetzt registrieren",
    "signIn": "Einloggen",
    "tryAgain": "Erneut versuchen",
    "goBack": "Zurück",
    "cancel": "Abbrechen",
    "deactivate": "Deaktivieren",
    "upgrade": "Upgraden",
    "upgradeToPremium": "Auf Premium upgraden",
    "upgradeNow": "Jetzt upgraden",
    "unlockPremiumFeatures": "Premium-Funktionen freischalten",
    "getMoreResultsAndFilters": "Mehr Ergebnisse und Filter erhalten",
    "goToConfig": "Zu den Voreinstellungen",
    "save": "Save",
    "close": "Schließen",
    "actions": "Aktionen",
    "copyToClipboard": "In die Zwischenablage kopieren",
    "saving": "Speichern…"
  },
  "loading": {
    "pleaseWait": "Bitte warten",
    "important": "Wichtig",
    "defaultWarning": "Bitte lade die Seite während dieses Vorgangs nicht neu.",
    "progressComplete": "{{percent}}% abgeschlossen",
    "loadingAriaLabel": "Lädt…",
    "loadingProgressAriaLabel": "Ladefortschritt: {{percent}}%"
  },
  "error": {
    "somethingWentWrong": "Etwas ist schiefgelaufen",
    "defaultMessage": "Ein Fehler ist aufgetreten! Warte ein paar Sekunden und lade die Seite neu.",
    "fetchDataFailed": "Auktionsdaten konnten nicht geladen werden"
  },
  "cancelDialog": {
    "title": "Abonnement kündigen",
    "confirmQuestion": "Bist du sicher, dass du dein Abonnement kündigen möchtest?",
    "loseAccessNotice": "Du verlierst den Zugriff auf die Tools und wirst nicht mehr durch zukünftige Zahlungen belastet.",
    "warning": "Warnung: Sobald du dein Abonnement kündigst, verlierst du nach Ablauf deines bezahlten Zugangs den Zugriff auf die Tools. Für gekündigte Abonnements erfolgt keine Rückerstattung."
  },
  "dialog": {
    "confirm": "Bestätigen",
    "cancel": "Abbrechen"
  },
  "realmLimitPopup": {
    "title": "Server-Limit überschritten",
    "description": "Du hast mehr Verkaufs-Server ausgewählt, als das Basic-Abonnement zulässt. Bitte ändere deine Einstellungen oder upgrade auf Premium."
  },
  "tooltipOverlay": {
    "upgradeTitle": "Auf Premium upgraden",
    "upgradeSubtitle": "Entfalte die volle Kraft von Flipping Pal",
    "enhancedFeatures": "Erweiterte Funktionen",
    "exclusiveFeatures": "Exklusive Premium-Funktionen",
    "alsoIncluded": "Ebenfalls enthalten"
  },
  "footer": {
    "changelog": "Änderungsprotokoll"
  },
  "logoAlt": "Flipping Pal – deine liebste WoW-Flipping-Seite",
  "toggleNavAriaLabel": "Navigationsmenü umschalten",
  "mainNavAriaLabel": "Hauptnavigation",
  "toolNavAriaLabel": "Tool-Navigation",
  "simpleNavAriaLabel": "Einfache Navigation",
  "footerNavAriaLabel": "Fusszeilen-Navigation",
  "clipboard": {
    "copied": "In die Zwischenablage kopiert!",
    "tsmCopied": "TSM-String in die Zwischenablage kopiert!",
    "exportCopied": "Exportcode erfolgreich in die Zwischenablage kopiert.",
    "auctionatorCopied": "Auctionator-Einkaufslisten in die Zwischenablage kopiert!",
    "titleCopied": "{{title}} in die Zwischenablage kopiert!",
    "copyFailed": "Kopieren in die Zwischenablage fehlgeschlagen"
  },
  "favorites": {
    "added": "Zu Favoriten hinzugefügt",
    "removed": "Aus Favoriten entfernt"
  },
  "enabled": "aktiviert",
  "disabled": "deaktiviert",
  "dataRefreshed": "Daten aktualisiert! {{count}} Möglichkeiten gefunden.",
  "notFound": {
    "title": "Seite nicht gefunden"
  },
  "paymentSuccess": {
    "title": "Zahlung erfolgreich"
  },
  "pagination": {
    "summary": "Gefundene Artikel gesamt: {{total}} | Ergebnisse pro Seite: {{perPage}}",
    "summaryWithPages": "Gefundene Artikel gesamt: {{total}} | Ergebnisse pro Seite: {{perPage}} | Seiten gesamt: {{pages}}",
    "label": "Seitennavigation",
    "firstPage": "Erste Seite",
    "previousPage": "Vorherige Seite",
    "nextPage": "Nächste Seite",
    "lastPage": "Letzte Seite",
    "pageAriaLabel": "Seite {{page}}"
  },
  "stats": {
    "totalInvestment": "Gesamtinvestition",
    "estimatedSellPrice": "Geschätzter Verkaufspreis",
    "profitAfterAHCut": "Profit nach Abzug der AH-Gebühr"
  },
  "filters": {
    "searchItems": "Artikel suchen...",
    "watchVideoGuide": "Videoanleitung ansehen",
    "watchVideoIntro": "Videoeinführung ansehen",
    "crossRealmVideoGuide": "Videoguide: Serverübergreifendes Flipping-Tool",
    "dropshipVideoGuide": "Videoguide: Dropship-Flipping-Tool",
    "housingVideoGuide": "Housing-Videoguide",
    "downloadXLSX": "Daten als Excel-Datei herunterladen",
    "getAuctionatorLists": "Auctionator-Liste erstellen",
    "quality": "Qualität",
    "selectQuality": "Qualität auswählen",
    "qualities": "Qualitäten",
    "expansions": "Erweiterungen",
    "selectExpansions": "Erweiterungen auswählen",
    "expansionsMultiple": "Erweiterungen",
    "sellingRealms": "Verkaufsserver",
    "selectSellingRealms": "Verkaufsserver auswählen",
    "sellingRealmsMultiple": "Verkaufsserver",
    "buyingRealms": "Kaufserver",
    "selectBuyingRealms": "Kaufserver auswählen",
    "buyingRealmsMultiple": "Kaufserver",
    "categories": "Kategorien",
    "selectCategories": "Kategorien auswählen",
    "categoriesMultiple": "Kategorien",
    "sellRate": "Verkaufsrate",
    "saleAvg": "Verkaufsdurchschnittspreis",
    "haveCraftedItems": "Gefertigte Gegenstände",
    "profitOnSaleAvg": "Gewinn auf Verkaufs Ø",
    "saleAvgVsBuyPercent": "Verkaufsdurchschnitt vs. Kauf %",
    "profitSellVsBuy": "Gewinn (Verkauf vs. Kauf)",
    "profitPercent": "Gewinn %",
    "maxGoldBuyout": "Max. Gold-Sofortkauf",
    "ilvl": "Gegenstandsstufe",
    "activateProfitOnSaleAvg": "Aktiviere Gewinn auf Verkaufs Ø",
    "regionMarketValue": "Regionaler Marktwert",
    "regionHistorical": "Regionaler historischer Wert",
    "modeRecalculate": "Neu berechnen",
    "modeFilter": "Filtern",
    "modeRecalculateHint": "Filteränderungen berechnen die Ergebnisse auf dem Server neu",
    "modeFilterHint": "Filteränderungen grenzen nur die bereits geladenen Ergebnisse ein",
    "modeAria": "Verhalten bei Filteränderungen",
    "modeLabel": "Bei Filteränderung"
  },
  "table": {
    "noData": "Keine Daten gefunden",
    "sellVsBuyTooltip": "Die 5% AH-Gebühr wird bei der Gewinnberechnung berücksichtigt",
    "toggleAllFavorites": "Alle Favoriten umschalten",
    "clickToCopy": "Klicken zum Kopieren: {{name}}",
    "priceAfterAHCut": "Preis nach AH-Gebühr: {{price}}",
    "noCompetition": "Keine Konkurrenz",
    "noCompetitionTooltip": "Kein bekanntes Angebot im Verkaufs-Server.",
    "population": "Bevölkerung: {{population}}",
    "viewOnWowhead": "{{name}} auf Wowhead anzeigen",
    "addToFavorites": "Zu Favoriten hinzufügen",
    "removeFromFavorites": "Aus Favoriten entfernen",
    "sessionExpiredFavorite": "Sitzung abgelaufen. Bitte erneut einloggen.",
    "failedToUpdateFavorite": "Favorit konnte nicht aktualisiert werden",
    "addSnipeAlert": "Snipe-Alarm hinzufügen",
    "editSnipeAlert": "Snipe-Alarm bearbeiten",
    "headers": {
      "itemName": "Gegenstand",
      "category": "Kategorie",
      "ilvl": "Itemstufe",
      "sellRate": "Verkaufsrate",
      "expansion": "Erweiterung",
      "quality": "Qualität",
      "extraStats": "Extra-Werte",
      "saleAvg": "Verkaufsdurchschn.",
      "regionMarketValue": "Regions-MW",
      "saleAvgVsBuy": "Verkaufsdurchschn. vs Kauf",
      "sellVsBuy": "Verkauf vs Kauf",
      "sellPrice": "Verkaufspreis",
      "sellRealm": "Verkaufsrealm",
      "buyPrice": "Kaufpreis",
      "buyRealm": "Kaufrealm"
    },
    "columnsTitle": "Spalten",
    "columnsReset": "Zurücksetzen",
    "columnsDragToReorder": "Zum Umordnen ziehen",
    "columnsToggleVisibility": "Auge anklicken, um Sichtbarkeit umzuschalten",
    "columnSettings": "Spalten-Einstellungen",
    "dragReorder": "{{column}} zum Umordnen ziehen",
    "hideColumn": "{{column}} ausblenden",
    "showColumn": "{{column}} anzeigen",
    "rowActions": "Zeilenaktionen",
    "actions": {
      "selectionSection": "Auswahl",
      "pinSection": "Oben anheften",
      "selectPage": "Seite auswählen",
      "deselectPage": "Seite abwählen",
      "selectAll": "Alle auswählen",
      "deselectAll": "Alle abwählen",
      "sortFavorites": "Favoriten anheften",
      "sortSnipes": "Snipe-Alarme anheften",
      "sortSelected": "Ausgewählte anheften",
      "columnSettings": "Spalten-Einstellungen..."
    },
    "sortHint": "Klicken zum Sortieren",
    "sortHintMulti": "Klicken zum Sortieren · Shift+Klick für sekundäre Sortierung",
    "selectRow": "{{name}} auswählen",
    "emptyFiltered": "Keine Gegenstände entsprechen deinen aktuellen Filtern",
    "emptyResetFilters": "Filter zurücksetzen",
    "emptyUpdating": "Eine Regionsaktualisierung läuft — neue Daten erscheinen in Kürze."
  },
  "multipleSelect": {
    "noResults": "Keine Ergebnisse gefunden",
    "selectAll": "Alle auswählen",
    "clearAll": "Alle abwählen",
    "selectOption": "Option auswählen",
    "selectMultipleOptions": "Mehrere Optionen auswählen",
    "selected": "ausgewählt",
    "searchOptions": "Optionen suchen",
    "noItemsSelected": "Keine Elemente ausgewählt",
    "search": "Suchen...",
    "items": "Gegenstände"
  },
  "hierarchicalSelect": {
    "selectAll": "Alle auswählen",
    "clearAll": "Alle abwählen",
    "expand": "Ausklappen",
    "collapse": "Einklappen",
    "selected": "ausgewählt",
    "noItemsSelected": "Kategorien auswählen...",
    "items": "Kategorien",
    "triggerAriaLabel": "{{items}} auswählen. {{count}} ausgewählt."
  },
  "hoverChart": {
    "high": "Hoch:",
    "low": "Tief:",
    "avg": "Ø:"
  },
  "tokenDisplay": {
    "label": "WoW-Marke",
    "signalBuy": "Kaufsignal — der Preis ist gerade günstig",
    "signalWait": "Warten — der Preis fällt voraussichtlich weiter",
    "signalHold": "Halten — derzeit kein klarer Trend",
    "loading": "Wird geladen...",
    "error": "Fehler",
    "priceHistory": "14-Tage Preisverlauf",
    "high": "Hoch: ",
    "low": "Tief: ",
    "avg": "Ø:",
    "momentum": "Trendstärke",
    "slowing": "Verlangsamend ({{steps}})",
    "atCap": "Am 1%-Limit",
    "steps": "{{count}} Schritt",
    "stepsPlural": "{{count}} Schritte"
  },
  "nextUpdate": {
    "nextDataUpdate": "Nächste Datenaktualisierung",
    "dataSourceStatus": "Datenquellenstatus",
    "tsmData": "TSM-Daten:",
    "blizzardRealm": "Blizzard-Server:",
    "liveUpdates": "Live-Updates:",
    "connected": "Verbunden",
    "reconnecting": "Verbindung wird hergestellt...",
    "retry": "Erneut versuchen",
    "autoRefresh": "Automatische Aktualisierung:",
    "autoRefreshEnabled": "Seite wird automatisch aktualisiert, wenn neue Daten verfügbar sind",
    "autoRefreshDisabled": "Klicke auf das Aktualisierungssymbol, wenn neue Daten bereit sind",
    "loadingStatus": "Datenstatus wird geladen...",
    "viewStatus": "Datenquellenstatus anzeigen",
    "refreshData": "Daten aktualisieren",
    "reloading": "Wird neu geladen",
    "liveUpdatesConnected": "Live-Updates verbunden",
    "liveUpdatesReconnecting": "Verbindung wird hergestellt...",
    "tsmFresh": "TSM-Daten sind aktuell (< 24h)",
    "tsmStale24": "TSM-Daten sind nicht mehr akkurat (24-25h)",
    "tsmStale25": "TSM-Daten sind veraltet (> 25h)",
    "toggleAutoRefresh": "Automatische Aktualisierung umschalten"
  },
  "regionUpdateProgress": {
    "updating": "Regionsdaten werden aktualisiert",
    "realmsProgress": "{{updated}}/{{total}} Server ({{percent}}%)",
    "autoRefresh": "Daten werden automatisch aktualisiert, wenn sie bereit sind",
    "reloadPartial": "Teildaten verfügbar — jetzt laden"
  },
  "filterFlyout": {
    "filtersButton": "Filter",
    "loadingPresets": "Laden...",
    "selectPreset": "Filtervorlage auswählen...",
    "presetsSection": "Filtervorlage",
    "save": "Speichern",
    "update": "Aktualisieren",
    "delete": "Löschen",
    "export": "Exportieren",
    "import": "Importieren",
    "importPreset": "Filtervorlage importieren…",
    "presetNamePlaceholder": "Vorlagenname...",
    "shareCode": "Diesen Code teilen:",
    "copy": "Kopieren",
    "done": "Fertig",
    "pasteCodePlaceholder": "Code hier einfügen...",
    "applyFilters": "Filter anwenden",
    "resetFilters": "Filter zurücksetzen",
    "refreshNow": "Jetzt aktualisieren",
    "reset": "Zurücksetzen",
    "deletePresetTitle": "Preset löschen",
    "deletePresetMessage": "Möchtest du dieses Preset wirklich löschen? Dies kann nicht rückgängig gemacht werden."
  },
  "discord": {
    "title": "Discord-Integration",
    "description": "Verknüpfe dein Discord-Konto, um personalisierte Benachrichtigungen und Updates von unserem Bot zu erhalten.",
    "accountLinked": "Discord-Konto verknüpft",
    "connectedAs": "Verbunden als:",
    "unlink": "Trennen",
    "dmVerifiedBadge": "DMs verifiziert: Dein Discord kann Benachrichtigungen von unserem Bot empfangen.",
    "dmVerificationTitle": "DM-Verifizierung erforderlich",
    "dmVerificationDesc": "Um Benachrichtigungen zu aktivieren, müssen wir bestätigen, dass unser Bot dir Direktnachrichten senden kann. Stelle sicher, dass DMs für mindestens einen Server aktiviert sind, den du mit unserem Bot teilst.",
    "sendVerificationCode": "Verifizierungscode an mein Discord senden",
    "sendingCode": "Sende Code...",
    "codeSentInstructions": "Überprüfe deine Discord-DMs auf einen 6-stelligen Code von unserem Bot. Wenn du keine DM erhalten hast, überprüfe in Discord unter Einstellungen > Inhalt & Soziales > Soziale Berechtigungen, ob Direktnachrichten aktiviert sind.",
    "enterCodePlaceholder": "6-stelligen Code eingeben",
    "verify": "Verifizieren",
    "resendCode": "Code erneut senden",
    "notificationSettings": "Benachrichtigungseinstellungen",
    "verifyDmsFirst": "(zuerst DMs verifizieren)",
    "botFeaturesAvailable": "Bot-Funktionen verfügbar: Du kannst jetzt private Nachrichten für Regionsupdate, Item- & Pet-Snipes, iLvl-BoE-Snipes und WoW-Tokenpreis erhalten.",
    "notConnected": "Nicht verbunden: Verknüpfe dein Discord-Konto, um Bot-Benachrichtigungen und -Funktionen zu aktivieren.",
    "connectingToDiscord": "Mit Discord verbinden...",
    "linkAccount": "Discord-Konto verknüpfen",
    "regionUpdateLabel": "Regionsupdate-Benachrichtigungen",
    "regionUpdateDesc": "Benachrichtigungen erhalten, wenn Auktionsdaten für deine ausgewählten Regionen aktualisiert werden.",
    "sendTestDm": "Test-DM senden",
    "sendingTest": "Wird gesendet…",
    "sendTestWebhook": "Test",
    "testMessageHint": "Sende eine Testnachricht, um zu prüfen, ob die Discord-Zustellung funktioniert, ohne auf einen echten Snipe zu warten.",
    "categoriesTitle": "Benachrichtigungskategorien",
    "categoriesDesc": "Leite Snipe-Alarme an verschiedene Discord-Kanäle weiter. Jede Kategorie hat ihre eigene Webhook-URL und ihren eigenen Erwähnungsmodus.",
    "categoriesPremiumHint": "Zusätzliche Kategorien erfordern ein Premium-Abonnement.",
    "categoryNamePlaceholder": "Kategoriename",
    "webhookUrlPlaceholder": "https://discord.com/api/webhooks/...",
    "mentionLabel": "Erwähnung:",
    "defaultLabel": "Standard",
    "defaultCategoryTitle": "Standardkategorie",
    "noWebhookSet": "kein Webhook festgelegt",
    "setAsDefault": "Als Standard festlegen",
    "edit": "Bearbeiten",
    "delete": "Löschen",
    "add": "Hinzufügen",
    "addCategory": "+ Kategorie hinzufügen",
    "deleteCategoryTitle": "Kategorie löschen",
    "deleteCategoryMessage": "Möchtest du die Kategorie „{{name}}“ wirklich löschen? Zugewiesene Alarme verwenden stattdessen deine Standardkategorie."
  },
  "csvExport": {
    "title": "CSV-Export",
    "noItems": "Keine Elemente verfügbar.",
    "copy": "In Zwischenablage kopieren",
    "copied": "CSV in Zwischenablage kopiert!",
    "copyFailed": "Kopieren fehlgeschlagen",
    "download": "CSV herunterladen"
  },
  "updateBanner": {
    "title": "Update verfügbar",
    "description": "Eine neue Version ist bereit.",
    "reload": "Neu laden",
    "dismiss": "Schließen"
  },
  "premiumPreviewBanner": {
    "title": "Du hast vollen Premium-Zugriff",
    "dayLeftOne": "Noch 1 Tag",
    "daysLeft": "Noch {{count}} Tage",
    "dismiss": "Schließen"
  },
  "tour": {
    "start": "Tour für diese Seite starten"
  },
  "filterSidebar": {
    "profitRange": "Gewinnspanne",
    "crafted_include": "Alle Gegenstände",
    "crafted_excluded": "Hergestellte ausschließen",
    "crafted_exclusive": "Nur hergestellte",
    "showPositiveSaleAvgVsBuy": "Nur positives Verkaufsdurchschnitt vs. Kauf",
    "presetClickToDeselect": "Klicken, um Voreinstellung abzuwählen",
    "collapseSidebar": "Filter einklappen",
    "expandSidebar": "Filter ausklappen"
  },
  "dashboard": {
    "loadError": "Dashboard-Daten konnten nicht geladen werden. Prüfe deine Verbindung und versuche es erneut.",
    "greeting": {
      "morning": "Guten Morgen",
      "afternoon": "Guten Tag",
      "evening": "Guten Abend"
    },
    "subtitle": "Hier ist, was heute auf dem Auktionshaus passiert.",
    "kpi": {
      "opportunities": "Möglichkeiten"
    },
    "topOpportunities": {
      "title": "Top-Möglichkeiten",
      "viewAll": "Alle anzeigen",
      "itemsFound": "Gegenstände über",
      "realms": "Realms gefunden",
      "openTool": "Flipping-Tool öffnen",
      "ilvl": "ilvl",
      "sellRate": "Verkaufsrate",
      "tabFastSelling": "Fast Selling",
      "tabTopBuys": "Top Buys",
      "sellRateMin": "Sell Rate ≥",
      "buyBelowPct": "Buy Below",
      "noItems": "No items match the current filters",
      "saveFailed": "Einstellungen konnten nicht gespeichert werden. Der letzte gespeicherte Wert wurde wiederhergestellt.",
      "saved": "Gespeichert",
      "sellRateTooltip": "Die Verkaufsrate liegt auf einer Skala von 0–1: der Anteil der eingestellten Auktionen, die täglich tatsächlich verkauft werden. 0,1 ≈ 10 % der Angebote."
    },
    "recentSnipes": {
      "title": "Letzte Snipes",
      "monitoringRealms": "{{count}} Realms werden überwacht",
      "vsTarget": "vs. Ziel",
      "itemsMonitored": "Gegenstände werden überwacht",
      "configureAlerts": "Benachrichtigungen konfigurieren",
      "noSnipes": "Keine Snipes in diesem Zyklus",
      "saved": "gespart"
    },
    "topRealms": {
      "title": "Top Realms",
      "sortPopVsAuctions": "Population vs Auctions",
      "sortPriceRatio": "Price Ratio",
      "sortNumAuctions": "Number of Auctions",
      "viewRealmStats": "Realm-Statistiken ansehen"
    },
    "quickAccess": {
      "title": "Schnellzugriff"
    },
    "onboarding": {
      "title": "Erste Schritte",
      "progress": "{{done}}/{{total}} erledigt",
      "hide": "Checkliste ausblenden",
      "steps": {
        "realms": "Konfiguriere deine Realms",
        "preset": "Erstelle eine Starter-Filtervoreinstellung",
        "flipping": "Führe deinen ersten Flipping-Scan aus",
        "discordLink": "Verknüpfe deinen Discord-Account",
        "snipe": "Richte Snipe-Benachrichtigungen ein",
        "discordJoin": "Tritt dem Discord-Server bei"
      },
      "createPreset": "Voreinstellung erstellen",
      "creatingPreset": "Wird erstellt…",
      "starterPresetName": "Starter",
      "configureRealmsFirst": "Konfiguriere zuerst deine Realms, um eine Voreinstellung zu erstellen",
      "presetLimitReached": "Du hast dein Limit für gespeicherte Voreinstellungen erreicht",
      "createPresetFailed": "Voreinstellung konnte nicht erstellt werden. Bitte versuche es erneut."
    },
    "activity": {
      "title": "Aktivität",
      "timeAgoLess1m": "<1 Min",
      "timeAgoMinutes": "vor {{count}} Min",
      "timeAgoHours": "vor {{count}} Std",
      "dataRefreshed": "Daten aktualisiert — {{n}} Möglichkeiten gefunden",
      "realmDataUpdated": "{{region}}-Realm-Daten aktualisiert",
      "waitingForData": "Warte auf erste Datenaktualisierung…",
      "snipeAlertsActive": "Snipe-Benachrichtigungen sind aktiv und überwachen deine Realms",
      "tokenTracked": "WoW-Token-Preis wird alle 20 Minuten aktualisiert"
    }
  },
  "versionSwitcher": {
    "label": "Game version",
    "retail": "Retail",
    "classicEra": "Classic Era",
    "switchFailed": "Failed to switch game version"
  },
  "classicDeals": {
    "title": "Classic Deals",
    "subtitle": "Buy items listed far below the next-cheapest copy on the same realm, then relist for a profit.",
    "region": "Region",
    "realms": "Realms",
    "selectRealms": "Select realms",
    "realmsSelected": "realms selected",
    "saveRealms": "Save realms",
    "findDeals": "Find deals",
    "loading": "Loading…",
    "selectRealmFirst": "Select at least one realm first",
    "saveFailed": "Failed to save realms",
    "realmsSaved": "Realms saved",
    "fetchFailed": "Failed to load deals",
    "noDeals": "No deals found for the selected realms.",
    "emptyPrompt": "Select your realms and click Find deals.",
    "colItem": "Item",
    "colRealm": "Realm",
    "colLowest": "Lowest",
    "colNext": "Next",
    "colProfit": "Profit",
    "colGap": "Gap",
    "colQty": "Qty",
    "colSaleRate": "Sale rate"
  },
  "backToTop": "Zurück nach oben",
  "slider": {
    "min": "Min",
    "max": "Max",
    "minAriaLabel": "Minimalwert",
    "maxAriaLabel": "Maximalwert",
    "numericInput": "{{label}} Zahleneingabe"
  },
  "inputBox": {
    "clear": "Eingabe löschen",
    "required": "erforderlich"
  },
  "auctionator": {
    "title": "Auctionator-Einkaufslisten",
    "account": "Konto:",
    "allAccounts": "Alle Konten",
    "noItems": "Keine Gegenstände für das ausgewählte Konto verfügbar."
  },
  "popup": {
    "getTitle": "{{title}} erhalten",
    "content": "Inhalt",
    "noContent": "Kein Inhalt verfügbar",
    "copyTitle": "{{title}} kopieren",
    "copyContent": "Inhalt kopieren",
    "titleContent": "{{title}}-Inhalt",
    "videoContent": "Videoinhalt",
    "videoNotSupported": "Dein Browser unterstützt das Video-Tag nicht."
  },
  "snipePopup": {
    "ariaLabel": "Snipe-Alarm für {{name}}",
    "titleItem": "Gegenstand-Snipe-Alarm",
    "titlePet": "Haustier-Snipe-Alarm",
    "maxBuyoutPrice": "Maximaler Sofortkaufpreis",
    "pricePlaceholder": "z. B. 500g oder 500g 50s",
    "saving": "Speichern...",
    "updateAlert": "Alarm aktualisieren",
    "setAlert": "Alarm setzen"
  },
  "refreshingData": "Daten werden aktualisiert...",
  "toolAccess": {
    "subscriptionRequired": "Du benötigst ein aktives Abonnement, um dieses Tool zu nutzen!",
    "premiumRequired": "Du benötigst ein aktives Premium-Abonnement, um dieses Tool zu nutzen!"
  }
}
